/* Tur 4 C: kisisel beden metni (misafir) + davet karosu kapatma. Ag istegi yok; beden hicbir yere gonderilmez. */
(function () {
  var D = document.documentElement, s = D.getAttribute('data-ag-size');
  var E = { 34: '’ü', 36: '’yı', 38: '’i', 40: '’ı', 42: '’yi', 44: '’ü', 46: '’yı' };
  var H = { 34: 'XS', 36: 'S', 38: 'M', 40: 'L', 42: 'XL', 44: 'XXL' };
  if (s && s !== 'none') {
    document.querySelectorAll('[data-ag-sz]').forEach(function (el) {
      var t = el.querySelector('[data-ag-sz-text]'), m = el.className.match(/ag-fit-(\w+)/);
      if (!t || !m || t.textContent.trim()) return;
      var f = m[1], r = +s + (f === 'dar' ? 2 : 0);
      var ok = el.classList.contains('ag-sz-ok-' + s), oos = el.classList.contains('ag-sz-oos-' + s);
      if (!ok && !oos) return;
      var hr = H[r] || r;
      if (el.getAttribute('data-ag-sz') === 'card') t.textContent = ok ? 'Senin bedenin: ' + hr : 'Senin bedenin: ' + hr + ' · şu an tükendi';
      else t.textContent = 'Senin bedenin: ' + hr + (oos ? ' · şu an tükendi' : '');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ag-size-invite-close]');
    if (!b) return;
    e.preventDefault();
    try { localStorage.setItem('ag:sizeInviteOff', String(Date.now())); } catch (x) {}
    D.setAttribute('data-ag-size-invite', 'off');
  });
})();
